// export const BASE_URL = "https://api-beta.lywo.in/"; /* Stage */

export const BASE_URL_AI = ' https://api.genai.stage.lywo.in/' // stage


// Azure Vase Url

// export const BASE_URL = 'https://lywo-admin-dnet-d0eadshrhvgdbxg4.eastus-01.azurewebsites.net/'
// export const BASE_URL = "https://api-admin-lywo.azurewebsites.net/"

// export const BASE_URL = 'https://api.lywo.in/'

export const BASE_URL = 'https://api-test.lywo.in/' // test

// export const BASE_URL = 'https://api-qa-lywo-beta-f5fxbdbqdjgbg0cv.southindia-01.azurewebsites.net/'

// wifi url

// export const BASE_URL = 'https://wifiattendancecloud.azurewebsites.net/'

export const ApiConfig = {
  BASE_URL_SHARE: "",

  LOGIN_WITH_UNIQUE_CODE: BASE_URL + "api/Account/GetUniqueCodeJobDetails",
  REGISTRATION_FORM: BASE_URL + "api/Account/AutheriseEmailAddCandidate",
  ASSESMENT_TEST:
    BASE_URL + "api/Assessment/GetAssessmentQustionsWithPreviousAnswers",
  TOKEN_ACCESS: BASE_URL + "api/Account/GetToken",
  ADD_ASSESSMENT_RESULT: BASE_URL + "api/Assessment/SubmitAssessment",
  ASSESSMENT_PICTURE: BASE_URL + "api/Assessment/GetImage/",
  GET_SPECIALIZATIONS: BASE_URL + "api/CommonDropDown/GetSpecializations",
  SUBMIT_ADDITIONINFO:
    BASE_URL + "api/CandidateMgmt/AddEditCandidateAdditionaldtls",
  GET_ADDITIONINFO: BASE_URL + "api/CandidateMgmt/GetAdditionalDtls",
  GET_LANG: BASE_URL + "api/Account/GetLanguagePreference?UserId=",
  UPDATE_LANG: BASE_URL + 'api/Account/UpdateLanguagePreference?',
  GET_CUSTOM_QUESTIONS: BASE_URL + "api/Organization/GetCustomQuestion",
  GET_INDUSTRY_LIST: BASE_URL + "api/Organization/GetIndustryList",
  GET_ASSESSMENT_DETAILS: BASE_URL + 'api/Job/GetSaveQuizOptions?',
  GET_QUIZE_QUESTIONS: BASE_URL + 'api/Job/SubmittedQuizOptions',
  SUBMIT_QUIZ: BASE_URL + 'api/Job/SubmitQuiz',
  GET_ACCESS_TOKEN_BY_USER_ID: BASE_URL + 'api/Account/GetTokenByUser',
  GET_COMAPNY_ABOUT_JOB: BASE_URL + "api/Job/GetJobAndCompanyDetails?jobcode=",
  GET_DEPARTMENTS: BASE_URL + 'api/CommonDropDown/GetDepartmentsList',
  UPDATE_USER_LOGIN_DETAILS: BASE_URL + 'api/CandidateMgmt/ChangeBasicDetails',
  GET_APPLICATION_STATUS: BASE_URL + 'api/Assessment/GetCurrentStep?',
  SEND_EMAIL_FOR_GET_APP_PROSS: BASE_URL + 'api/Assessment/SendEmail5',
  CHECK_USER_EXIST_IN_SAME_JOB: BASE_URL + "api/Job/ChangedDetails",
  UPDATE_NOT_INTERESTED: BASE_URL + 'api/CandidateMgmt/MarkCandidateNotInterested',
  GET_IS_INTERSTED: BASE_URL + 'api/CandidateMgmt/GetCandidateNotInterested',
  UPDATE_QUIZ_START: BASE_URL + 'api/Assessment/MarkQuizStarted?',
  DOWNLOAD_JOB_DESCRIPTION: BASE_URL + 'api/Job/ExportJDWord',
  DOWNLOAD_JOB_DESCRIPTION_PDF:BASE_URL+'api/Job/ExportJDPDF',
  SEND_OTP: BASE_URL + 'api/CandidateMgmt/SendOtp',
  VERIFY_OTP: BASE_URL + 'api/CandidateMgmt/VerifyOtp',
  DOWNLOAD_ABOUT_AND_RESUME:BASE_URL+'api/Job/GetUserProcessData',


  PARSED_RESUME: BASE_URL_AI + 'jd_creation/candidate_resume_parsing'
};
export default ApiConfig;
